import React from 'react';
import { Button, Form, Icon } from 'antd';
import PropTypes from 'prop-types';
import { getSubFormFieldByTypeForTpwModule, sanitizeFieldName } from '../../util/methods';
import Descriptions from "antd/lib/descriptions";

let spareQty = [], spareRate = [], labourQty = [], labourRate = [], spareTotal = [], labourTotal = [],
  spareTotalSum = 0, uom = [],
  labourTotalSum = 0, spareCost = [], labourCost = [];

class SubList extends React.Component {
  id = 0;
  state = {
    keys: [],
    uom: [],
    flag: false,
    fieldInvoice: '',
    selectedSpares: {},
    selectedLabours: {},
  };

  componentDidMount() {
    const { data = [{}], item } = this.props;
    const selectedSpares = {};
    const selectedLabours = {};

    // Initialize selected values from existing data
    if (data && data.length && item && item.field) {
      data.forEach((entry, index) => {
        if (item.field === 'spareRequired' && entry && entry.sparePart) {
          const spareId = entry.sparePart._id || entry.sparePart;
          selectedSpares[index] = spareId;
        }
        if (item.field === 'labourRequired' && entry && entry.labour) {
          const labourId = entry.labour._id || entry.labour;
          selectedLabours[index] = labourId;
        }
      });
    }

    this.setState({
      keys: data,
      selectedSpares,
      selectedLabours,
    });
  }

  getTotalAmountForInvoice(field) {
    let totalSum = 0;
    const { form } = this.props;
    if (field && field === 'spareRequired') {
      let sum = 0;
      if (spareCost && spareCost.length) {
        for (let i = 0; i < spareCost.length; i++) {
          sum = sum + spareCost[i];
        }
        ;
        totalSum = sum;
        if (labourCost && labourCost.length) {
          for (let i = 0; i < labourCost.length; i++) {
            totalSum = totalSum + labourCost[i];
          }
        }
        if (this.props.valueSelected === 'tpwNo') {
          this.props.storeTotalData(totalSum, field, '');
        }
        return <Descriptions bordered title="">
          <Descriptions.Item label={`Total ${field === 'spareRequired' ? 'Spare' : field === 'labourRequired' ? 'Labour' : ''} amount`}>
            {
              sum && sum !== 0 && sum.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              })
            }
          </Descriptions.Item>
        </Descriptions>
      }
      else {
        sum = 0;
      }
    }

    if (field && field === 'labourRequired') {
      let sum = 0;
      if (labourCost && labourCost.length) {
        for (let i = 0; i < labourCost.length; i++) {
          sum = sum + labourCost[i];
        }
        totalSum = sum;

        if (spareCost && spareCost.length) {
          for (let i = 0; i < spareCost.length; i++) {
            totalSum = totalSum + spareCost[i];
          }
          ;
        }

        if (this.props.valueSelected === 'tpwNo') {
          this.props.storeTotalData(totalSum, field, '');
        }

        return <Descriptions bordered title="">
          <Descriptions.Item label="Total amount">
            {
              sum && sum !== 0 && sum.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              })
            }
          </Descriptions.Item>
        </Descriptions>
      }
      else {
        sum = 0;
      }
    }
  }

  getTotalAmount(field) {
    const { form } = this.props;
    if (field && field === 'spareRequired') {
      if (spareTotal && spareTotal.length) {
        let sum = 0;
        for (let i = 0; i < spareTotal.length; i++) {
          sum = sum + spareTotal[i];
        }
        spareTotalSum = sum;
        return <Descriptions bordered title="">
          <Descriptions.Item label={`Total ${field === 'spareRequired' ? 'Spare' : field === 'labourRequired' ? 'Labour' : ''} amount`}>
            {
              spareTotalSum && spareTotalSum !== 0 && spareTotalSum.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              })
            }
          </Descriptions.Item>
        </Descriptions>
      }
      else {
        spareTotalSum = 0;
      }
    }

    if (field && field === 'labourRequired') {
      if (labourTotal && labourTotal.length) {
        let sum = 0;
        for (let i = 0; i < labourTotal.length; i++) {
          sum = sum + labourTotal[i];
        }
        labourTotalSum = sum;
        return <Descriptions bordered title="">
          <Descriptions.Item label="Total amount">
            {
              labourTotalSum && labourTotalSum !== 0 && labourTotalSum.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              })
            }
          </Descriptions.Item>
        </Descriptions>
      }
      else {
        labourTotalSum = 0;
      }
    }
  }

  getTotalAmountOnEditForInvoice(field) {
    const { form, data } = this.props;
    if (data && data.length) {
      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].totalCost) {
          if (field && field === 'spareRequired') {
            spareCost[i] = data[i].totalCost;
          }
          if (field && field === 'labourRequired') {
            labourCost[i] = data[i].totalCost;
          }
          sum = sum + data[i].totalCost;
        }
      }
      return <Descriptions bordered title="">
        <Descriptions.Item
          label={`Total ${field === 'spareRequired' ? 'Spare' : field === 'labourRequired' ? 'Labour' : ''} amount`}>
          {
            sum && sum !== 0 && sum.toLocaleString('en-IN', {
              maximumFractionDigits: 2,
              style: 'currency',
              currency: 'INR'
            })
          }
        </Descriptions.Item>
      </Descriptions>
    }
  }

  getTotalAmountOnEdit(field) {
    const { form, data } = this.props;
    if (data && data.length) {
      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].totalCost) {
          sum = sum + data[i].totalCost;
        }
      }
      spareTotalSum = sum;
      return <Descriptions bordered title="">
        <Descriptions.Item label={`Total ${field === 'spareRequired' ? 'Spare' : field === 'labourRequired' ? 'Labour' : ''} amount`}>
          {
            spareTotalSum && spareTotalSum !== 0 && spareTotalSum.toLocaleString('en-IN', {
              maximumFractionDigits: 2,
              style: 'currency',
              currency: 'INR'
            })
          }
        </Descriptions.Item>
      </Descriptions>
    }
  }

  handleSubChange = (e, ind, modelField, formField, field) => {
    const { form, resource } = this.props;
    // console.log(this.props);
    if (resource && resource === 'InvoiceEntry') {
      if (field && field === 'spareRequired') {
        if (modelField && modelField === 'noOfUnits') {
          spareQty[ind] = e.target.value;
          const unitRate = form.getFieldValue(`spareRequired[${ind}][unitRate]`);
          if (unitRate) {
            spareTotal[ind] = spareQty[ind] * unitRate;
            spareCost[ind] = spareTotal[ind] || 0;
            form.setFieldsValue({
              [`spareRequired[${ind}][totalCost]`]: spareTotal[ind],
            });
            this.props.storeTotalData(spareTotal[ind], field, ind);
          }
        }
        if (modelField && modelField === 'unitRate') {
          spareRate[ind] = e.target.value;
          const units = form.getFieldValue(`spareRequired[${ind}][noOfUnits]`);
          if (units) {
            spareTotal[ind] = spareRate[ind] * units;
            spareCost[ind] = spareTotal[ind] || 0;
            form.setFieldsValue({
              [`spareRequired[${ind}][totalCost]`]: spareTotal[ind],
            });
            this.props.storeTotalData(spareTotal[ind], field, ind);
          }
        }
      }

      else if (field && field === 'labourRequired') {
        if (modelField && modelField === 'noOfUnits') {
          labourQty[ind] = e.target.value;
          const unitRate = form.getFieldValue(`labourRequired[${ind}][unitRate]`);
          if (unitRate) {
            labourTotal[ind] = labourQty[ind] * unitRate;
            labourCost[ind] = labourTotal[ind] || 0;

            form.setFieldsValue({
              [`labourRequired[${ind}][totalCost]`]: labourTotal[ind],
            });

            if (this.props.valueSelected !== 'tpwNo') {
              this.props.storeTotalData(labourTotal[ind], field, ind);
            }
          }
        }
        if (modelField && modelField === 'unitRate') {
          labourRate[ind] = e.target.value;
          const units = form.getFieldValue(`labourRequired[${ind}][noOfUnits]`);
          if (units) {
            labourTotal[ind] = labourRate[ind] * units;
            labourCost[ind] = labourTotal[ind] || 0;
            form.setFieldsValue({
              [`labourRequired[${ind}][totalCost]`]: labourTotal[ind],
            });

            if (this.props.valueSelected !== 'tpwNo') {
              this.props.storeTotalData(labourTotal[ind], field, ind);
            }
          }
        }
      }
      this.setState({ flag: true, fieldInvoice: field });
    }
    else {
      if (field && field === 'spareRequired') {
        if (modelField && modelField === 'noOfUnits') {
          spareQty[ind] = e.target.value;
        }

        if (modelField && modelField === 'unitRate') {
          spareRate[ind] = e.target.value;
        }

        if (spareQty && spareQty.length && spareRate && spareRate.length) {
          spareTotal[ind] = (spareQty[ind]) * (spareRate[ind]);
          form.setFieldsValue({
            [`spareRequired[${ind}][totalCost]`]: spareTotal[ind],
          });
          this.props.storeTotalData(spareTotal[ind], field, ind);
        }
      } else if (field && field === 'labourRequired') {
        if (modelField && modelField === 'noOfUnits') {
          labourQty[ind] = e.target.value;
        }

        if (modelField && modelField === 'unitRate') {
          labourRate[ind] = e.target.value;
        }

        if (labourQty && labourQty.length && labourRate && labourRate.length) {
          labourTotal[ind] = (labourQty[ind]) * (labourRate[ind]);
          form.setFieldsValue({
            [`labourRequired[${ind}][totalCost]`]: labourTotal[ind],
          });
          this.props.storeTotalData(labourTotal[ind], field, ind);
        }
      }
    }
  }

  componentWillUnmount() {
    spareQty = [];
    spareRate = [];
    labourQty = [];
    labourRate = [];
    spareTotal = [];
    labourTotal = [];
    spareTotalSum = 0;
    uom = [];
    labourTotalSum = 0;
    labourCost = [];
    spareCost = [];
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      const { item } = nextProps;
      const selectedSpares = {};
      const selectedLabours = {};

      // Re-initialize selected values when data changes
      if (nextProps.data && nextProps.data.length && item && item.field) {
        nextProps.data.forEach((entry, index) => {
          if (item.field === 'spareRequired' && entry && entry.sparePart) {
            const spareId = entry.sparePart._id || entry.sparePart;
            selectedSpares[index] = spareId;
          }
          if (item.field === 'labourRequired' && entry && entry.labour) {
            const labourId = entry.labour._id || entry.labour;
            selectedLabours[index] = labourId;
          }
        });
      }

      this.setState({
        keys: nextProps.data,
        selectedSpares,
        selectedLabours,
      });
    }
  }

  handleSpareOrLabourSelect = (value, index, fieldType) => {
    if (fieldType === 'sparePart') {
      this.setState(prevState => ({
        selectedSpares: {
          ...prevState.selectedSpares,
          [index]: value
        }
      }));
    } else if (fieldType === 'labour') {
      this.setState(prevState => ({
        selectedLabours: {
          ...prevState.selectedLabours,
          [index]: value
        }
      }));
    }
  }

  getExcludedIds = (index, fieldType) => {
    const selectedMap = fieldType === 'sparePart' ? this.state.selectedSpares : this.state.selectedLabours;
    const excludedIds = [];
    Object.keys(selectedMap).forEach(key => {
      if (parseInt(key) !== index && selectedMap[key]) {
        excludedIds.push(selectedMap[key]);
      }
    });
    return excludedIds;
  }

  remove = (index, formField) => {
    let sendSum = 0;
    const { keys, selectedSpares, selectedLabours } = this.state;
    const { form, item, resource } = this.props;
    const { field } = item;
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);
    keys.splice(index, 1);

    if (resource && resource === 'ThirdPartyWorkQuotation') {
      val && val.map((values, ind) => {
        if (values && values.totalCost) {
          this.props.storeTotalData(values.totalCost, field, ind, index);
        }
      });
    }

    if (resource && resource === 'InvoiceEntry') {
      if (this.props.valueSelected !== 'tpwNo') {
        val && val.map((values, ind) => {
          if (values && values.totalCost) {
            this.props.storeTotalData(values.totalCost, field, ind, index);
          }
        });
      }
      else if (this.props.valueSelected === 'tpwNo') {
        this.setState({ flag: true, fieldInvoice: field })
      }
    }

    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }

    if (formField && formField === 'spareRequired') {
      if (spareTotal && spareTotal.length) {
        spareTotal[index] = 0;
        spareCost[index] = 0;
      }
      if (spareQty && spareQty.length) {
        spareQty[index] = 0;
      }
      if (spareRate && spareRate.length) {
        spareRate[index] = 0;
      }

      // Rebuild selectedSpares with updated indices after removal
      const newSelectedSpares = {};
      Object.keys(selectedSpares).forEach(key => {
        const keyIndex = parseInt(key);
        if (keyIndex < index) {
          newSelectedSpares[keyIndex] = selectedSpares[key];
        } else if (keyIndex > index) {
          newSelectedSpares[keyIndex - 1] = selectedSpares[key];
        }
      });
      this.setState({ selectedSpares: newSelectedSpares });
    }

    if (formField && formField === 'labourRequired') {
      if (labourTotal && labourTotal.length) {
        labourTotal[index] = 0;
        labourCost[index] = 0;
      }
      if (labourQty && labourQty.length) {
        labourQty[index] = 0;
      }
      if (labourRate && labourRate.length) {
        labourRate[index] = 0;
      }

      // Rebuild selectedLabours with updated indices after removal
      const newSelectedLabours = {};
      Object.keys(selectedLabours).forEach(key => {
        const keyIndex = parseInt(key);
        if (keyIndex < index) {
          newSelectedLabours[keyIndex] = selectedLabours[key];
        } else if (keyIndex > index) {
          newSelectedLabours[keyIndex - 1] = selectedLabours[key];
        }
      });
      this.setState({ selectedLabours: newSelectedLabours });
    }

    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    if (this.props.resource === 'Invoice Entry' && this.props.valueSelected === 'tpwNo') {
      this.setState({ flag: true, fieldInvoice: field, keys: keys });
    }
    else {
      this.setState({
        keys: keys,
      });
    }
  };

  onSpareSelect = (spareNameId, index) => {
    const { searchData, form } = this.props;
    const spareName = searchData && searchData.filter(item => JSON.stringify(item._id) === JSON.stringify(spareNameId));
    uom[index] = spareName && spareName.length && spareName[0].unitOfMeasurement._id;
    this.setState({ uom: uom });
  }

  render() {
    const { form, item, data = [], hideAddButton = false, resource, superMaster, subMaster, title = '', disableAll = false } = this.props;
    const { field } = item;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const tpwStyle = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between'
    }

    const formItems = keys.map((k, index) => (
      <div key={index} style={tpwStyle}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
            if ((resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry') && fieldName !== 'complaint') {
              // Get excluded IDs for duplicate prevention (only for spareparts)
              const excludedSpareIds = field === 'spareRequired' ? this.getExcludedIds(index, 'sparePart') : [];

              return getSubFormFieldByTypeForTpwModule(item.schema[fieldName], getFieldDecorator, data[index], (item && item.field) ? `${item.field}${index}${innerIndex}` : `${index}${innerIndex}`, field, index, {
                title: 'CREATE',
                resource,
                superMaster: (superMaster || false),
                subMaster: (subMaster || false),
                setFieldsValue,
                getFieldDecorator,
                handleSubChange: this.handleSubChange,
                onSpareSelect: this.onSpareSelect,
                uom: (this.state.uom[index] || []),
                disableAll: disableAll,
                excludedSpareIds,
                handleSpareOrLabourSelect: this.handleSpareOrLabourSelect
              });
            }
          })
        }
        {keys && keys.length && index && index === (keys.length - 1) && !hideAddButton && !disableAll ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index, field)}
          />
        ) : null}
      </div>
    ));

    return (
      <div>
        {formItems}

        <div style={{ display: "flex", flexDirection: "row", justifyContent: 'space-between' }}>
          <div style={{ width: '48%' }}>
            {
              this.props && this.props.hideAddButton ? <br /> : <Form.Item>
                <Button
                  disabled={title && title === 'EDIT' && resource && (resource === 'ThirdPartyWorkQuotation' || resource === 'InvoiceEntry')}
                  type="dashed" onClick={this.add} style={{ width: '100%', marginTop: '15px' }}>
                  <Icon type="plus" /> Add {sanitizeFieldName(item.field)}
                </Button>
              </Form.Item>
            }
          </div>
          {
            resource && resource === 'InvoiceEntry' ?
              <div style={{ marginTop: '15px', width: '48%' }}>
                {
                  title === 'EDIT' ? this.getTotalAmountOnEditForInvoice(field) : (this.state.flag) ? this.getTotalAmountForInvoice(this.state.fieldInvoice) : this.getTotalAmountOnEditForInvoice(field)
                }
              </div> : ''
          }
          {
            resource && resource !== 'InvoiceEntry' ?
              <div style={{ marginTop: '15px', width: '48%' }}>
                {title === 'EDIT' ? this.getTotalAmountOnEdit(field) : this.getTotalAmount(field)}
              </div> : ''
          }
        </div>
      </div>
    );
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
